module.exports = __webpack_public_path__ + "static/media/download.5c815597.svg";